<template>
<div class="slide-function">
    <div class="page__header">
        <div class="search-question" data-step="4">Do you want a multifunction oven?</div>
    </div>
    <div class="page__content">
        <div class="page__wrap">
            <div class="func__options">
                <button @click="filterByMultifunction(true)">Yes</button>
                <button @click="filterByMultifunction(false)">No</button>
            </div>
            <button v-if="!isWebApp"  class="multifunction-oven"  @click="showVideo">
                <i class="fas fa-play-circle"></i>
                What is the multifunction oven?
            </button>
            <p>The multifunction oven offers up to eight functions for truly flexible cooking. From crisping up the base of your pizza to browning your favourite pasta dish. The multifunction oven offers up to eight functions; Defrost, Fan Oven, Fanned Grilling, Fan Assisted Oven, Conventional Oven, Browning Element , Base Heat and Rapid Response.</p>
            <div class="icons">
                <div class="icon" v-bind:class="{tooltip__active: tooltip.defrost}">
                    <img src="static/func-icon1.png" @click="toggleTooltip('defrost')">
                </div>
                <div class="function__tooltip" v-if="tooltip.defrost">
                    <p><strong>Defrost</strong></p>
                    <p>The fan only with no heat draws cold air from the frozen food to speed up defrosting.</p>
                </div>
                <div class="icon" v-bind:class="{tooltip__active: tooltip.fanOven}" @click="toggleTooltip('fanOven')">
                    <img src="static/func-icon2.png">
                </div>
                <div class="function__tooltip" v-if="tooltip.fanOven">
                    <p><strong>Fan Oven</strong></p>
                    <p>Uses an element at the back of the fan, the fan forces the heat into the cavity making the cavity the same temp throughout. Ideal for batch baking or different foods at the same temperature.</p>
                </div>
                <div class="icon" v-bind:class="{tooltip__active: tooltip.fannedGrilling}">
                    <img src="static/func-icon3.png" @click="toggleTooltip('fannedGrilling')">
                </div>
                <div class="function__tooltip" v-if="tooltip.fannedGrilling">
                    <p><strong>Fannded Grilling</strong></p>
                    <p>Using the top heat element in conjunction with the fan the fanned grill provides a grilled effect without the need to turn the food. Grill with the door closed, no need to turn the food.</p>
                </div>
                <div class="icon" v-bind:class="{tooltip__active: tooltip.fanAssistedOven}">
                    <img src="static/func-icon4.png" @click="toggleTooltip('fanAssistedOven')">
                </div>
                <div class="function__tooltip" v-if="tooltip.fanAssistedOven">
                    <p><strong>Fan Assisted Oven</strong></p>
                    <p>Uses elements at the top and bottom of the oven with the fan assisting the cooking process. The cavity is hotter at the top cooler at the bottom. Crisp and brown the top and bottom as well as cooking through.</p>
                </div>
                <div class="icon" v-bind:class="{tooltip__active: tooltip.conventionalOven}">
                    <img src="static/func-icon5.png" @click="toggleTooltip('conventionalOven')">
                </div>
                <div class="function__tooltip" v-if="tooltip.conventionalOven">
                    <p><strong>Conventional Oven</strong></p>
                    <p>Traditional cooking method using top and bottom heat and zoned cooking. Much hotter at the top than the bottom. Ideal for traditional baking e.g soufflé.</p>
                </div>
                <div class="icon" v-bind:class="{tooltip__active: tooltip.browningElement}">
                    <img src="static/func-icon6.png" @click="toggleTooltip('browningElement')">
                </div>
                <div class="function__tooltip" v-if="tooltip.browningElement">
                    <p><strong>Browning Element</strong></p>
                    <p>Using the top exposed element only to offer a very high intense heat for browning and toasting.</p>
                </div>
                <div class="icon" v-bind:class="{tooltip__active: tooltip.baseHeat}">
                    <img src="static/func-icon7.png" @click="toggleTooltip('baseHeat')">
                </div>
                <div class="function__tooltip" v-if="tooltip.baseHeat">
                    <p><strong>Base Heat</strong></p>
                    <p>Using an element n the bottom only the base heat can be used for slow gentle cooking or high heat for crisping up the base.</p>
                </div>
                <div class="icon" v-bind:class="{tooltip__active: tooltip.rapidResponse}">
                    <img src="static/func-icon8.png" @click="toggleTooltip('rapidResponse')">
                </div>
                <div class="function__tooltip" v-if="tooltip.rapidResponse">
                    <p><strong>Rapid Response</strong></p>
                    <p>Rapid heat up time for any dish or ready meal. Heats up 30% quicker than fan alone. For fanned cooking only*. *Selected models.</p>
                </div>
            </div>
        </div>
    </div>
    <video-modal src="/static/multifunction.mp4" @click="showVideo" v-if="displayVideo"/>
</div>
</template>
<script>
import { isWebApp } from "../../api/index.js";
export default {
    data: function(){
        return {
            displayVideo: false,
            tooltip: {
                defrost: false,
                fanOven: false,
                fannedGrilling: false,
                fanAssistedOven: false,
                conventionalOven: false,
                browningElement: false,
                baseHeat: false,
                rapidResponse: false
            },
            isWebApp: isWebApp()
        }
    },
    methods: {
        filterByMultifunction(isFunc){
            this.$ga.event('filter', 'multifunction', isFunc ? "Yes": "No" );
            this.$router.push({ name: 'results', params:{...this.$route.params, function: ( isFunc ? "multifunction" : "normal" ) } })
        },
        showVideo(){
            this.displayVideo = !this.displayVideo;
        },
        toggleTooltip(key){
            Object.keys(this.tooltip).forEach((k)=>{
                if(k != key){
                    this.tooltip[k] = false;
                }
            });
            this.tooltip[key] = !this.tooltip[key];
        }
    },
  mounted(){
    this.$ga.screenview('multifunction');
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/slide-4-func.vue